document.addEventListener('DOMContentLoaded', () => {
  // Get the Select elements in the current document
  const elem = document.querySelectorAll<HTMLSelectElement>('[id=candidate_job_position_id]');
  // The dom parser is used for creating a translated message for the select
  const parser = new DOMParser();

  /**
   * Open/Close the add-new-position modal
   * @param {boolean} shouldOpen
   */
  function setModalState(shouldOpen: boolean) {
    // Get the add-new-position modal
    const modalElem = document.getElementById('add-position-modal');

    if (shouldOpen) {
      return modalElem.setAttribute('class', 'modal show');
    } else {
      return modalElem.setAttribute('class', 'modal');
    }
  }

  for (let index = 0; index < elem.length; index++) {
    const element = elem[index];
    // Get and parse the translation message form the data attr.
    const translation = parser.parseFromString(element.dataset.addtranslation, 'text/html').body;

    // Create a new option, set the text to the translated message.
    const opt = document.createElement('option');
    opt.appendChild(translation);
    opt.setAttribute('value', 'new-position');
    element.options.add(opt);

    // If the new option is chosen, open the modal..
    element.addEventListener('change', function (event) {
      const target = event.target as HTMLSelectElement;
      if (target.value === 'new-position') {
        setModalState(true);
      }
    });
  }

  function handleNewPositionCompletion(event: CustomEvent<[{ id: number; title: string }, string, XMLHttpRequest]>) {
    const parsedData = event.detail[0];

    // Close the modal
    setModalState(false);

    for (let index = 0; index < elem.length; index++) {
      const element = elem[index];
      // Create a new option, set the value and text to the response data
      const option = document.createElement('option');
      option.text = parsedData.title;
      option.setAttribute('value', String(parsedData.id));
      element.add(option);

      // Select the new option
      element.value = String(parsedData.id);
    }
  }

  function handleNewPositionFailure(event: CustomEvent<[{ error?: string }, string, XMLHttpRequest]>) {
    const message = event.detail[0]?.error;
    window.toastr.error(message || 'The position could not be created.');
  }

  const addPositionForm = document.getElementById('addPositionForm');
  if (addPositionForm) {
    addPositionForm.addEventListener('ajax:success', handleNewPositionCompletion, false);
    addPositionForm.addEventListener('ajax:error', handleNewPositionFailure, false);
  }
});
